import React from 'react'
import GlobalMapObjectSelect from './GlobalMapObjectSelect'
import MultiSelect from './MultiSelect'
import { IGlobalMapObject } from '@api/types'
interface MultiMapObjectSelectProps {
  values: IGlobalMapObject[]
  onChange: (items: IGlobalMapObject[]) => void
}

export default function MultiMapObjectSelect({ values, onChange }: MultiMapObjectSelectProps) {
  const buttonProps = {
    iconName: 'plus',
    minimal: true,
    blue: true,
  }

  return (
    <MultiSelect
      title="Pins"
      values={values.map((v, i) => (
        <span key={v.id}>{v.name}</span>
      ))}
      select={
        <GlobalMapObjectSelect
          multi
          itemDisabled={({ id }) => !!values.find((item) => item.id === id)}
          onChange={(mo) =>
            values.find(({ id }) => id === mo.id)
              ? onChange(values.filter(({ id }) => id !== mo.id))
              : onChange([...values, mo])
          }
          value={null}
          btnText="Add"
          {...{ buttonProps }}
        />
      }
      onRemove={(objectId) => onChange(values.filter((av) => av.id !== objectId))}
    />
  )
}
